import _ from 'underscore';
import Backbone from 'backbone';

import tpl from './booster-subscription-template.hbs';
import { eventBus } from '../state-manager/event-bus';
import { domainReplacer } from '../utils/domain-replacer';
import { LINKS } from '../config';
import { getStoreType } from '../utils/parse-store-type';

export var BoosterSubscriptionView = Backbone.View.extend({
  tagName: 'div',

  template: tpl,

  initialize: function () {
    this.model.fetch();
    this.listenTo(this.model, 'sync', this.render);
    this.replaceURL = domainReplacer.create();
    this.eventBus = eventBus;
  },

  events: {
    'click [data-booster-click=close]': 'close',
    'click [data-booster-click=changePayment]': 'changePayment',
    'click [data-booster-click=rollback]': 'rollback',
    'click [data-booster-click=unsubscribe]': 'unsubscribe'
  },

  changePayment: function (e) {
    e.preventDefault();
    window.open(this.replaceURL(LINKS.myPayment));
  },

  rollback: function (e) {
    e.preventDefault();
    var isPossible = this.model.get('canChangeStatus');

    if (isPossible) {
      this.eventBus.trigger('show:message', {
        title: '부스터 해지 예약 취소',
        message: [
          '부스터 해지 예약이 되어있습니다.',
          '해지 예약을 취소 하시겠습니까?',
          '<em>※ 결제 예정일 하루 전에는 해지 예약 취소가 제한 됩니다.</em>'
        ],
        options: {
          onConfirm: _.bind(function () {
            this.model.save();
          }, this),
          confirmText: '해지 예약 취소',
          onCancel: function () {},
          cancelText: '취소'
        }
      });
    } else {
      this.eventBus.trigger('show:message', {
        title: '부스터 해지 예약 취소',
        message: [
          '결제 예정일에는 해지 예약 취소를 할 수 없습니다.',
          '이후 다시 해지 예약해주세요.'
        ]
      });
    }
  },

  unsubscribe: function (e) {
    e.preventDefault();
    var isPossible = this.model.get('canChangeStatus');

    if (isPossible) {
      this.eventBus.trigger('show:message', {
        title: '부스터 해지 예약',
        message: [
          '부스터 해지 예약 시',
          '다음 결제일부터 결제가 되지 않습니다.',
          '정말 해지하시겠습니까?',
          '<em>※ 결제 예정일 하루 전에는 해지 예약이 제한 됩니다.</em>'
        ],
        options: {
          onConfirm: _.bind(function () {
            this.model.save();
          }, this),
          confirmText: '해지 예약',
          onCancel: function () {},
          cancelText: '취소'
        }
      });
    } else {
      this.eventBus.trigger('show:message', {
        title: '부스터 해지 예약',
        message: [
          '결제 예정일에는 해지 예약 취소를 할 수 없습니다.',
          '이후 다시 해지 예약해주세요.'
        ]
      });
    }
  },

  close: function (e) {
    e.preventDefault();
    this.remove();

    var platform = this.getPlatform();
    if (platform.isMobileGame) {
      location.assign(LINKS.closeWebview);
    } else if (platform.isPCGame) {
      try {
        setTimeout(function () {
          window.close();
        }, 10);
        location.assign(LINKS.closeWebview);
      } catch (e) {
        console.log('Error closing window:', e);
      }
    }
  },

  getPlatform: function () {
    var storeType = getStoreType();
    var isFromClient = location.pathname.split('/').pop() === 'booster-subscription' && storeType;
    var isMobileGame = isFromClient && storeType !== 'p'; // p = PC
    var isPCGame = isFromClient && storeType === 'p';
    var isIOS = isFromClient && storeType === 'i';
    var isAndroid = isFromClient && storeType.startsWith('g'); // gk, gb 등이 있을 수 있음
    var isPCWeb = !isFromClient;
    var isPC = isPCGame || isPCWeb;

    /** @type {'google-class' | 'pc-class' | 'ios-class' | 'pc-pass'} */
    var paidPlatform = this.model.get('paidPlatform');

    // 구 pc-pass는 pc-class와 동일하게 취급
    paidPlatform = paidPlatform === 'pc-pass' ? 'pc-class' : paidPlatform;

    /** @type {'mobile' | 'pc-game' | 'pc-web'} */
    var currentPlatform;
    if (isMobileGame) currentPlatform = 'mobile';
    else if (isPCGame) currentPlatform = 'pc-game';
    else if (isPCWeb) currentPlatform = 'pc-web';

    return {
      platformDetail: currentPlatform + '/' + paidPlatform,
      isMobileGame: isMobileGame,
      isPCGame: isPCGame,
      isPCWeb: isPCWeb,
      isPC: isPC,
      isIOS: isIOS,
      isAndroid: isAndroid
    };
  },

  render: function () {
    var platform = this.getPlatform();
    var context = _.extend(platform, this.model.toJSON());
    var rendered = this.template(context);

    this.$el.html(rendered);

    if (this.model.get('isSuccess') && this.model.get('isCancelling')) {
      this.eventBus.trigger('show:message', {
        title: '부스터 해지 예약',
        message: ['부스터 해지 예약이 되었습니다.', '다음 결제일부터 결제가 되지 않습니다.']
      });
    }
    return this;
  }
});
